import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    consumertxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "22px",
        lineHeight: "28px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#091E42",
        marginTop: "30px",
        marginBottom:"15px"
    },
    noConsumertxt: {
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "22px",
        lineHeight: "28px",
        display: "flex",
        alignItems: "center",
        letterSpacing: "-0.001em",
        color: "#091E42"
    },
}))